import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { trans } from '../../../../_providers/Translation'
import '../../../../assets/css/partials/PartsList.css'
import moment from 'moment'

function ContractorsList({ recentParts, loading }) {

    if (loading) {
        return <Skeleton height={60} count={6} />
    }

    if (recentParts.length === 0) {
        return (
            <div className="alert info">
                Не бяха открити части.
            </div>
        )
    }

    return (
        <table>
            <thead>
                <tr>
                    <th>Име</th>
                    <th>Тип</th>
                    <th>{trans('tables.addedAt')}</th>
                </tr>
            </thead>

            <tbody>
                {recentParts.map((part, idx) => (
                    <tr key={part.id}>
                        <td>
                            {part.name}
                        </td>
                        <td>
                            <div className='action'>
                                {part.type_name}
                            </div>
                        </td>
                        <td>
                            {moment(part.date_added).format('DD.MM.YYYY / HH:mm')}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default ContractorsList